import api from "../index";

export const LoginApi = (data) => api.post('Authentication/User-Login', data);
export const OtpApi = (data) => api.post('Authentication/LoginOtp-Verify', data);
export const SendOtpApi = (userId) => api.put(`Authentication/Resend-Otp/${userId}`);
export const RegisterApi = (data) => api.post('UserMaster/User-Register', data);
export const ResetApi = (data) => api.post('Authentication/Forgot-Password', data);
export const ChangePasswordApi = (data) => api.put('Authentication/Change-Password', data);
export const UpdateParentVisibilityApi = (userId, params) => api.patch(`UserMaster/update-parent-detail-show-status/${userId}?${params}`);
export const LogoutApi = (data) => api.post('Authentication/Logout', data);
export const ClearNotificationApi = () => api.delete(`Notification/user/ClearAllNotifications`);
export const MarkAsReadNotificationApi = (notificationId) => api.put(`Notification/UpdateNotificationStatus/${notificationId}?IsRead=true`);
export const SendemailApi = (data) => api.post(`Authentication/SendOtp-Email`, data);
export const GetUserApi = (userId) => api.get(`UserMaster/User-GetById/${userId}`);
export const UpdateUserApi = (data, apiHeader) => api.put('UserMaster/User-Update', data, apiHeader);
export const ForgetOtpApi = (data) => api.post('Authentication/Forgot-Password-VerifyOtp', data);
export const GetParentTreeApi = (params) => api.get(`UserMaster/IBParentTree-UserById/${params}`);
export const GetNotificationApi = () => api.get('Notification/GetUserMessages');
export const Request2faChangeApi = (userId) => api.put(`UserMaster/Request-2fa-Change?IsEnable=${userId}`);
export const ForgetOtp2FAApi = (data) => api.put('UserMaster/Verify-2fa-Change', data);

